import Rest from "@/services/Rest";

export default class ProcedureService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/procedures'

  async createCsv(entity) {
    const formData = new FormData();
    formData.append('uploadedCsv', entity)
    return await this.post('/uploadProcedures', formData, {
      headers: {
        "content-type": "multipart/form-data"
      }
    });
  }

}
